import ReceiptComissioned from './ReceiptComissioned';

export default ReceiptComissioned;